import React, { Component } from 'react';
import { bool, func, number, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actions as marketIndexActions } from '../Common/MarketIndexState';
import { actions as organizationStatisticsActions } from '../Common/OrganizationStatisticsState';
import MarketAnalysisDisplay from './MarketAnalysisDisplay';
import LoadingMarketAnalysis from '../../SupportingComponents/LoadingStates/LoadingMarketAnalysis';

const EMPLOYEES_URL = '/iframe/merit/hris/employee/employees';

class MarketAnalysis extends Component {
  static propTypes = {
    dispatch: func,
    employeesCount: number,
    marketIndex: shape({
      data: shape({
        employeeDataEffectiveDate: string,
        employeesPricedSlotted: number,
        marketIndex: shape({
          base: number,
          totalCash: number
        })
      }),
      error: string,
      loading: bool
    }),
    onTotalEmployeesClick: func
  };

  componentDidMount() {
    const { dispatch } = this.props;
    marketIndexActions.getMarketIndex(dispatch);
    organizationStatisticsActions.getOrganizationStatistics(dispatch);
  }

  getDataPoint(dataPoint) {
    const placeholder = '-';
    return dataPoint >= 0 ? Math.round(dataPoint) : placeholder;
  }

  render() {
    const { employeesCount, marketIndex, onTotalEmployeesClick, history } = this.props;
    const { data, error, loading } = marketIndex;
    let employeesPricedSlotted, baseMarketIndex, totalCashIndex;

    if (loading || !!error.length) {
      return <LoadingMarketAnalysis />;
    }

    if (data.marketIndex) {
      employeesPricedSlotted = this.getDataPoint(data.employeesPricedSlotted);
      baseMarketIndex = this.getDataPoint(data.marketIndex.base);
      totalCashIndex = this.getDataPoint(data.marketIndex.totalCash);
    }

    return (
      <MarketAnalysisDisplay
        baseMarketIndexCount={baseMarketIndex}
        employeesCount={employeesCount}
        employeeDataEffectiveDate={data.employeeDataEffectiveDate}
        employeesPricedSlotted={employeesPricedSlotted}
        onTotalEmployeesClick={() => {
          history.push(EMPLOYEES_URL);
        }}
        totalCashMarketIndexCount={totalCashIndex}
      />
    );
  }
}

const mapStateToProps = ({ landingDashboard }) => ({
  marketIndex: landingDashboard.MarketIndex,
  employeesCount: landingDashboard.OrganizationStatistics.data.statistics?.orgCounts?.employees
});

export default withRouter(connect(mapStateToProps)(MarketAnalysis));
